export { default } from "bullitttime-embercomponents/components/ts-popover";
